import EntityModel from '@/common/models/entity-model';

export default class AttachmentModel extends EntityModel {
    hydrate({
        id = null,
        description = null,
        fileId = null,
        mimeType = null,
        name = null,
        relatedId = null,
        relatedType = null,
        blob = null,
    } = {}) {
        this.id = id;
        this.description = description;
        this.fileId = fileId;
        this.mimeType = mimeType;
        this.name = name;
        this.relatedId = relatedId;
        this.relatedType = relatedType;
        this.isTransfering = false;
        this.blob = blob;
    }

    get blobFormWrapper() {
        if (!this.blob) {
            return undefined;
        }
        const form = new FormData();
        form.append('file', this.blob);
        return {fileObject: form};
    }

    set file({id, mime}) {
        this.fileId = id;
        this.mimeType = mime;
    }
}
